export interface UserProfile {
  aud?: string;
  iss?: string;
  iat?: number;
  nbf?: number;
  exp?: number;
  amr?: string[];
  family_name?: string;
  given_name: string;
  ipaddr: string;
  name: string;
  nonce?: string;
  oid?: string;
  platf?: string;
  /** Subject - Identifier for the End-User at the Issuer. */
  sub?: string;
  tid?: string;
  unique_name: string;
  upn?: string;
  ver?: string;
}

export class SgUserProfile {
  /**
   * Unique id for the user
   */
  get id(): string {
    return this.baseProfile.sub;
  }
  name: string;
  accountName: string;

  constructor(public readonly baseProfile: UserProfile, accountName?: string) {
    this.name = baseProfile.name || '';
    this.givenName = baseProfile.given_name || '';
    this.familyName = baseProfile.family_name || '';
    this.accountName = accountName || '';
  }

  givenName: string;
  familyName: string;
}
